import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import App from "./LayoutMobile";

const NoPageFound = ({data}) => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title="404"
      subTitle={data || "Sorry, the page you visited does not exist."} 
      extra={
        <Button type="primary"  style={{  borderColor: '#008385' ,backgroundColor : '#008385'}} onClick={() => navigate("/")}>
          Back Home
        </Button>
      }
    />
  );
};

export default NoPageFound;
